import { Controller } from "@hotwired/stimulus"

// Signal level — a live character count on the contact textarea. The `out`
// cell prints length against the SAME limit the server enforces
// (Enquiry::MESSAGE_MAX_LENGTH, mirrored onto the textarea's maxlength), so the
// meter is a real measurement, not decoration — no meter without one. The out
// cell is .js-only, hidden until the bundle stamps html.js, so no-JS never
// shows an empty gauge.
//
// Controller element: the .field wrapping the Signal textarea.
export default class extends Controller {
  static targets = ["area", "out"]

  connect() {
    this.measure()
  }

  measure() {
    if (!this.hasAreaTarget || !this.hasOutTarget) return
    this.outTarget.textContent = `${this.areaTarget.value.length} / ${this.areaTarget.maxLength}`
  }
}
